var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F03C2E;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.1,42.8L67.2,20.9c-1.3-1.3-3.3-1.3-4.6,0l-4.5,4.5l5.7,5.7c1.3-0.5,2.9-0.1,3.9,0.9c1,1,1.4,2.6,0.9,4 l5.5,5.5c1.3-0.5,2.9-0.2,4,0.9c1.5,1.5,1.5,3.9,0,5.4c-0.5,0.5-1.1,0.8-1.7,1c-1.3,0.4-2.7,0-3.7-1c-1.1-1.1-1.4-2.8-0.8-4.2 l-5.2-5.2v13.6c0.4,0.2,0.7,0.4,1,0.7c1.5,1.5,1.5,3.9,0,5.4c-1.5,1.5-3.9,1.5-5.4,0c0,0,0,0,0,0c-1.5-1.5-1.5-3.9,0-5.4 c0.4-0.4,0.8-0.6,1.3-0.8V38.4c-0.4-0.2-0.9-0.5-1.3-0.8c-1.1-1.1-1.4-2.8-0.8-4.2l-5.7-5.7l-15,14.9c-1.3,1.3-1.3,3.3,0,4.6 l21.8,21.8c1.3,1.3,3.3,1.3,4.6,0l21.7-21.7C90.3,46.1,90.3,44,89.1,42.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/Git.9cd05a8f604112ca75af2a6934d92dd9.svg";
export { ForwardRef as ReactComponent };